<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/packages">arrow_back</mat-icon>
            <h3>{{ 'package.add.title' | translate }}</h3>
        </div>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'package.add.basicData' | translate }}</h4>
        <form novalidate [formGroup]="packageForm!">
            <div class="form-row">
                <label for="packageName">{{ 'package.add.name' | translate }} <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="packageName" id="packageName" type="text" required [(ngModel)]="package.packageName" />
                </div>
            </div>
            <div class="form-row">
                <label for="fileCover">{{ 'package.add.coverImage' | translate }} <span class="required">*</span></label>
                <div class="form-input file-row">
                    <button type="button" class="btn btn-file" onclick="document.getElementById('fileCover').click()">
                        {{ 'package.add.selectCover' | translate }}
                    </button>
                    @if (addCoverFile) {
                        <span>{{ fileCover?.name }}</span>
                    }
                    @if (!addCoverFile) {
                        <span class="no-file-text">{{ 'package.add.noCoverSelected' | translate }}</span>
                    }
                    <mat-icon class="delete-icon" (click)="clearSelectedCoverFile()">delete_forever</mat-icon>
                    <input
                        #fileCoverInput
                        id="fileCover"
                        type="file"
                        hidden
                        (change)="onChange($event)"
                    />
                </div>
            </div>
        </form>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'package.add.elements' | translate }}</h4>
        <div class="drag-and-drop-container">
            <div class="search-main-container">
                <div class="search-bar">
                    <mat-icon fontIcon="search" />
                    <input placeholder="{{ 'package.add.searchPlaceholder' | translate }}" type="search" [(ngModel)]="searchText" />
                </div>
                <div class="category-info">
                    @if (package.packageName) {
                        <span>{{ package.packageName }} — {{ 'package.add.elementCount' | translate }}: {{ packageProductList.length }}</span>
                    }
                    @if (!package.packageName) {
                        <span>{{ 'package.add.newPackage' | translate }} — {{ 'package.add.elementCount' | translate }}: {{ packageProductList.length }}</span>
                    }
                </div>
            </div>
            <div class="drag-and-drop">
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'package.add.availableProducts' | translate }}</h5>
                    <div class="products-list">
                        @for (product of products | filter: searchText; track product) {
                            <div class="product-item">
                                <span>{{ product.author + ': ' + product.title }}</span>
                                <mat-icon class="action-icon action-icon--add" (click)="addProductToPackage(product)">add_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'package.add.packageProducts' | translate }}</h5>
                    <div cdkDropList class="products-list" (cdkDropListDropped)="drop($event)">
                        @for (product of packageProductList; track product; let i = $index) {
                            <div cdkDrag class="product-item">
                                <mat-icon class="drag-handle" fontIcon="drag_indicator" />
                                <b class="order-number">{{ i + 1 }}</b>
                                <span>{{ product.author + ': ' + product.title }}</span>
                                <mat-icon class="action-icon action-icon--remove" (click)="deleteFromPackageProductList(product)">remove_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="sum-row">
            <span>{{ 'package.add.total' | translate }}</span>
            <b>{{ sum | currency: 'Ft' : 'symbol' : '1.0-0' }}</b>
        </div>

        <div class="submit-row">
            <button type="button" class="btn btn-submit" [disabled]="!package.packageName" (click)="addPackage()">
                {{ 'package.add.submitButton' | translate }}
            </button>
        </div>
    </div>
</div>
